export default {
  light: 1,
  pro: 2,
  digifarmz: 3,
  full: 4,
}
